import { useModule }          from '../../hooks/useModule'
import { PremiumPreview }     from './PremiumPreview'
import { isDeveloperMode }    from '../../lib/developer-mode'
import type { ModuleId }      from '../../types/module'

type Props = {
  moduleId: ModuleId
  children: React.ReactNode
}

export function ModuleGuard({ moduleId, children }: Props) {
  const { isSubscribed, config } = useModule(moduleId)

  // Developer mode bypasses the subscription gate so modules under development
  // can be inspected without a live subscription.  Never active in production.
  if (!isSubscribed && !isDeveloperMode()) return <PremiumPreview module={config} />

  return <>{children}</>
}
